import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const deleteTeam = async (id) => {
  try {
    const response = await apiClient.delete(`/teamManagement/${id}`);
    const successMessage = response?.data?.message || 'Team deleted successfully';
    notify('success', successMessage);
    return { success: true, data: response };
  } catch (error) {
    console.log(error);
    const errorMessage = error.response?.data?.error || 'Failed to delete team';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
